export default __webpack_public_path__ + "static/media/check-icon.bcb78854.svg";